import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { catchError, of } from 'rxjs';
import { MarketingAnnouncementComponent } from '../components/marketing-announcement.component';
import type { SiteAnnouncement } from '../../shared/models/marketing.models';
import { PagesService } from '../../shared/services/pages.service';

@Component({
  selector: 'app-marketing-layout',
  imports: [RouterOutlet, MarketingAnnouncementComponent],
  standalone: true,
  templateUrl: './marketing-layout.component.html',
})
export class MarketingLayoutComponent {
  private readonly pages = inject(PagesService);

  /** Fetched here so the shell (and child routes) are not blocked on this request. */
  readonly announcement = toSignal(
    this.pages.getSiteAnnouncement().pipe(catchError(() => of(undefined))),
    { initialValue: undefined as SiteAnnouncement | undefined },
  );
}
